/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EligibleDirectoryContactUser } from './EligibleDirectoryContactUser';
import {
    EligibleDirectoryContactUserFromJSON,
    EligibleDirectoryContactUserFromJSONTyped,
    EligibleDirectoryContactUserToJSON,
} from './EligibleDirectoryContactUser';

/**
 * 
 * @export
 * @interface ListEligibleDirectoryContactUsers200Response
 */
export interface ListEligibleDirectoryContactUsers200Response {
    /**
     * 
     * @type {Array<EligibleDirectoryContactUser>}
     * @memberof ListEligibleDirectoryContactUsers200Response
     */
    data?: Array<EligibleDirectoryContactUser>;
}

/**
 * Check if a given object implements the ListEligibleDirectoryContactUsers200Response interface.
 */
export function instanceOfListEligibleDirectoryContactUsers200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListEligibleDirectoryContactUsers200ResponseFromJSON(json: any): ListEligibleDirectoryContactUsers200Response {
    return ListEligibleDirectoryContactUsers200ResponseFromJSONTyped(json, false);
}

export function ListEligibleDirectoryContactUsers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEligibleDirectoryContactUsers200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(EligibleDirectoryContactUserFromJSON)),
    };
}

export function ListEligibleDirectoryContactUsers200ResponseToJSON(value?: ListEligibleDirectoryContactUsers200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(EligibleDirectoryContactUserToJSON)),
    };
}

